/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateUpdateAssessmentTargetSetCommand } from '../model/createUpdateAssessmentTargetSetCommand';
import { CreateUpdateAssessmentTargetSetCommandResult } from '../model/createUpdateAssessmentTargetSetCommandResult';
import { DeleteAssessmentTargetSetCommandResult } from '../model/deleteAssessmentTargetSetCommandResult';
import { GetAssessmentTargetSetQueryResult } from '../model/getAssessmentTargetSetQueryResult';
import { GetAssessmentTargetSetsQueryResult } from '../model/getAssessmentTargetSetsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AssessmentTargetSetsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [PORTAL] Creates or updates a target set
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assessmentTargetSetsCreateUpdatePost(body?: CreateUpdateAssessmentTargetSetCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUpdateAssessmentTargetSetCommandResult>;
    public assessmentTargetSetsCreateUpdatePost(body?: CreateUpdateAssessmentTargetSetCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUpdateAssessmentTargetSetCommandResult>>;
    public assessmentTargetSetsCreateUpdatePost(body?: CreateUpdateAssessmentTargetSetCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUpdateAssessmentTargetSetCommandResult>>;
    public assessmentTargetSetsCreateUpdatePost(body?: CreateUpdateAssessmentTargetSetCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUpdateAssessmentTargetSetCommandResult>('post',`${this.basePath}/AssessmentTargetSets/CreateUpdate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets target sets for an assignment
     * 
     * @param userAssessmentUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assessmentTargetSetsGet(userAssessmentUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAssessmentTargetSetsQueryResult>;
    public assessmentTargetSetsGet(userAssessmentUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAssessmentTargetSetsQueryResult>>;
    public assessmentTargetSetsGet(userAssessmentUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAssessmentTargetSetsQueryResult>>;
    public assessmentTargetSetsGet(userAssessmentUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userAssessmentUid !== undefined && userAssessmentUid !== null) {
            queryParameters = queryParameters.set('UserAssessmentUid', <any>userAssessmentUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetAssessmentTargetSetsQueryResult>('get',`${this.basePath}/AssessmentTargetSets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Deletes a target set
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assessmentTargetSetsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteAssessmentTargetSetCommandResult>;
    public assessmentTargetSetsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteAssessmentTargetSetCommandResult>>;
    public assessmentTargetSetsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteAssessmentTargetSetCommandResult>>;
    public assessmentTargetSetsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling assessmentTargetSetsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteAssessmentTargetSetCommandResult>('delete',`${this.basePath}/AssessmentTargetSets/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets a single target set
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assessmentTargetSetsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetAssessmentTargetSetQueryResult>;
    public assessmentTargetSetsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAssessmentTargetSetQueryResult>>;
    public assessmentTargetSetsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAssessmentTargetSetQueryResult>>;
    public assessmentTargetSetsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling assessmentTargetSetsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetAssessmentTargetSetQueryResult>('get',`${this.basePath}/AssessmentTargetSets/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
